<template>
  <b-modal
    id="edit-config-modal"
    centered
    size="lg"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
    dialog-class="my-dialog-class"
  >
    <template #modal-title>
      <h2 class="m-0 text-primary">Edit Config</h2>
    </template>
    <validation-observer ref="editConfigFormValidation">
      <b-form @submit.prevent>
        <b-form-row>
          <b-col md="6">
            <b-form-group label-for="androidPkgName">
              <template #label>
                Android Package Name <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Android Package Name"
                :rules="{ required }"
              >
                <b-form-input
                  id="androidPkgName"
                  v-model="androidPkgName"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Android Package Name"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label-for="iosTestPayment">
              <template #label> Ios Test Payment </template>
              <b-form-checkbox
                v-model="iosTestPayment"
                id="iosTestPayment"
                switch
              >
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col md="6">
            <b-form-group label-for="oneConnectApiKey">
              <template #label>
                OneConnect Key <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="OneConnect Key"
                :rules="{ required }"
              >
                <b-form-input
                  id="oneConnectApiKey"
                  v-model="oneConnectApiKey"
                  :state="errors.length > 0 ? false : null"
                  placeholder="OneConnect Key"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-form-row>
      </b-form>
    </validation-observer>
    <template #modal-footer>
      <b-form-group class="text-right">
        <b-button type="submit" variant="info" pill @click="validationForm">
          Update
        </b-button>
      </b-form-group>
    </template>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import util from "@/util.js";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    config: Object,
  },
  mixins: [util],
  data() {
    return {
      androidPkgName: "",
      iosTestPayment: false,
      oneConnectApiKey: "",
      required,
    };
  },
  async mounted() {
    if (this.config) {
      this.androidPkgName = this.config.android_pkg_name;
      this.iosTestPayment = this.config.ios_test_payment;
      this.oneConnectApiKey = this.config.one_connect_api_key;
    }
  },
  methods: {
    ...mapActions({
      updateConfig: "appData/updateConfig",
    }),
    async validationForm() {
      const success = await this.$refs.editConfigFormValidation.validate();
      if (success) {
        await this.submit();
      }
    },
    async submit() {
      try {
        const res = await this.updateConfig({
          payload: {
            android_pkg_name: this.androidPkgName,
            ios_test_payment: this.iosTestPayment,
            one_connect_api_key: this.oneConnectApiKey,
            updated_by: this.getLoggedInUser.id,
          },
          pk: this.config.id,
        });
        if (res.status === 200) {
          this.$swal({
            title: "Config updated successfully",
            icon: "success",
          });
          this.$nextTick(() => {
            this.$bvModal.hide("edit-config-modal");
          });
          this.$emit("modalClosed");
        }
      } catch (error) {
        this.displayError(error);
      }
    },
  },
  computed: {
    ...mapGetters({ getLoggedInUser: "appData/getLoggedInUser" }),
  },
};
</script>

<style scoped>
.scroll-area-size {
  height: 45vh;
}

.scroll-area-size ul {
  height: 100%;
}
</style>
